var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Question as QuestionMarkIcon } from '../../svgs';
import { DropContainer } from './DropContainer';
import { SupportMenu } from './SupportMenu';
export function SupportButton(_a) {
    var currentDropDown = _a.currentDropDown, setCurrentDropDown = _a.setCurrentDropDown, closeDropDown = _a.closeDropDown, dropdownSpacer = _a.dropdownSpacer, qMarkData = _a.qMarkData;
    return (_jsxs("div", __assign({ id: 'support-menu-button', className: "button " + (currentDropDown === 'support' ? 'active' : '') }, { children: [_jsx("button", __assign({ className: 'quiet', "aria-label": 'support menu', onClick: function () { return setCurrentDropDown('support'); } }, { children: _jsx(QuestionMarkIcon, {}, void 0) }), void 0),
            currentDropDown === 'support' && (_jsx(DropContainer, __assign({ closeDropDown: closeDropDown, verticalOffset: dropdownSpacer }, { children: _jsx(SupportMenu, { closeDropDown: closeDropDown }, void 0) }), void 0))] }), void 0));
}
